// TournamentsPage.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import tournamentSocket from './tournamentSocket';
import KnockoutScoreboard from './KnockoutScoreboard'
import './Lobby.css';

function TournamentsPage({ username }) {
  const navigate = useNavigate();
  const [allTournaments, setAllTournaments] = useState([]);








  
  useEffect(() => {
    function handleAllTournamentsUpdated(tournamentsArray) {
      console.log('[TournamentsPage] Получен список турниров:', tournamentsArray);
      // Показываем все турниры без фильтрации
      setAllTournaments(tournamentsArray);
    }
    tournamentSocket.on('responseAllTournaments', handleAllTournamentsUpdated);
    tournamentSocket.emit('requestAllTournaments');
    return () => {
      tournamentSocket.off('responseAllTournaments', handleAllTournamentsUpdated);
    };
  }, []);

  return (
    <div className="casino-background">
   

      <div className="tournaments-list">
        <h2>Список всех турниров (включая завершенные)</h2>
        {allTournaments.length === 0 ? (
          <p>Турниров пока нет.</p>
        ) : (
          <div className="game-cards">
            {allTournaments.map((t) => {
              const isRegistered =
                Array.isArray(t.registeredPlayers) && t.registeredPlayers.includes(username);
              return (
                <div className="game-card" key={t.id}>
                  <div className="game-header">
                    <span className="bet-price">${t.buyIn}</span>
                  </div>
                  <div className="game-image-wrapper">
                    <img src="/img/blok.png" alt="Game" className="game-image" />
                    <div className="game-info">
                      <p className="game-title">SIT AND GO &nbsp; {t.registeredCount}/{t.maxPlayers}</p>
                      <p className="prize">MAX PRIZE ${t.prize}</p>
                      {t.status === 'registration' ? (
                        <>
                          {isRegistered ? (
                            <button
                              className="game-button"
                              onClick={() => {
                                if (window.confirm('Отменить регистрацию?')) {
                                  tournamentSocket.emit('tournament_leaveTournament', { tournamentId: t.id, userName: username });
                                }
                              }}
                            >
                              Отменить регистрацию
                            </button>
                          ) : (
                            <>
                              {t.registeredCount < t.maxPlayers ? (
                                <button
                                  className="game-button"
                                  onClick={() => {
                                    if (window.confirm(`Принять участие в турнире c buyIn=$${t.buyIn}?`)) {
                                      tournamentSocket.emit('tournament_joinTournament', { tournamentId: t.id, userName: username });
                                    }
                                  }}
                                >
                                  Регистрация
                                </button>
                              ) : (
                                <p style={{ color: 'red' }}>Мест нет</p>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <p style={{ color: 'red' }}>{t.status.toUpperCase()}</p>
                      )}
                      {/* Если турнир не в статусе registration – отображаем кнопку для показа турнирной сетки */}
                      {t.status !== 'registration' && (
                        <button
                          className="game-button"
                          style={{ marginTop: '8px' }}
                          onClick={() => {
                            // Здесь можно реализовать локальное переключение показа сетки
                            // Например, добавить в объект турнира поле showBracket и обновить его через setState
                            setAllTournaments(prev =>
                              prev.map(item =>
                                item.id === t.id
                                  ? { ...item, showBracket: !item.showBracket }
                                  : item
                              )
                            );
                          }}
                        >
                          {t.showBracket ? 'Скрыть турнирную сетку' : 'Показать турнирную сетку'}
                        </button>
                      )}
                      {t.showBracket && (
                        <div style={{ marginTop: '1rem' }}>
                          <KnockoutScoreboard
                            semiTopP1={t.semiTopP1 || ''}
                            semiTopP2={t.semiTopP2 || ''}
                            semiTopScore1={t.semiTopScore1 ?? 0}
                            semiTopScore2={t.semiTopScore2 ?? 0}
                            semiBotP1={t.semiBotP1 || ''}
                            semiBotP2={t.semiBotP2 || ''}
                            semiBotScore1={t.semiBotScore1 ?? 0}
                            semiBotScore2={t.semiBotScore2 ?? 0}
                            finalP1={t.finalP1 || ''}
                            finalP2={t.finalP2 || ''}
                            finalScore1={t.finalScore1 ?? 0}
                            finalScore2={t.finalScore2 ?? 0}
                            championName={t.championName || ''}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default TournamentsPage;
 










// // TournamentsPage.jsx
// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useState, useEffect } from 'react';

// import TournamentLobby from './TournamentLobby';
// import './Lobby.css';
// import tournamentSocket from './tournamentSocket'; 

// function TournamentsPage({ username }) {
//   const navigate = useNavigate();
//   const [allTournaments, setAllTournaments] = useState([]);

//   useEffect(() => {
//     function handleAllTournamentsUpdated(tournamentsArray) {
//       console.log('[TournamentsPage] Получен список турниров:', tournamentsArray);
//       setAllTournaments(tournamentsArray);
//     }

//     tournamentSocket.on('responseAllTournaments', handleAllTournamentsUpdated);
//     tournamentSocket.emit('requestAllTournaments');

//     return () => {
//       tournamentSocket.off('responseAllTournaments', handleAllTournamentsUpdated);
//     };
//   }, []);

//   return (
//     <div className="casino-background">
//       <header className="header-banner">
//         <div className="logo">
//           <img src="/logo.png" alt="Logo" />
//           Ledis and Ganetmen
//         </div>

//         <nav className="menu">
//           <a
//             className="menu-item"
//             href="/"
//             onClick={(e) => {
//               e.preventDefault();
//               navigate('/');
//             }}
//           >
//             <span className="text">кеш</span>
//           </a>

//           <a
//             className="menu-item"
//             href="/tournamentsPage"
//             onClick={(e) => {
//               e.preventDefault();
//               navigate('/tournamentsPage');
//             }}
//           >
//             <span className="text">турниры</span>
//           </a>

//           <a
//             className="menu-item"
//             href="/quests"
//             onClick={(e) => {
//               e.preventDefault();
//               navigate('/quests');
//             }}
//           >
//             <span className="text">квесты</span>
//           </a>
//         </nav>

//         <div className="buttons">
//           <button className="button-login" onClick={() => navigate('/login')}>
//             Логин
//           </button>
//           <button className="button-register" onClick={() => navigate('/register')}>
//             Регистрация
//           </button>
//         </div>
//       </header>

//       <div className="tournaments-list">
//         <h2>Список всех турниров (включая finished)</h2>

//         {/* Если массив пуст, пишем "нет турниров", иначе рендерим */}
//         {allTournaments.length === 0 ? (
//           <p>Турниров пока нет.</p>
//         ) : (
//           // Применяем ту же структуру, что и в TournamentLobby
//           <div className="game-cards">
//             {allTournaments.map((t) => {
//               // Проверяем, зарегистрирован ли текущий user
//               const isRegistered = Array.isArray(t.registeredPlayers)
//                 ? t.registeredPlayers.includes(username)
//                 : false;

//               return (
//                 <div className="game-card" key={t.id}>
//                   <div className="game-header">
//                     <span className="bet-price">${t.buyIn}</span>
//                   </div>

//                   <div className="game-image-wrapper">
//                     <img src="/img/blok.png" alt="Game" className="game-image" />

//                     <div className="game-info">
//                       <p className="game-title">
//                         SIT AND GO &nbsp; {t.registeredCount}/{t.maxPlayers}
//                       </p>
//                       <p className="prize">MAX PRIZE ${t.prize}</p>

//                       {/* В зависимости от статуса: либо кнопки регистрации, либо надпись */}
//                       {t.status === 'registration' ? (
//                         <>
//                           {isRegistered ? (
//                             <button
//                               className="game-button"
//                               onClick={() => {
//                                 const ok = window.confirm('Отменить регистрацию?');
//                                 if (!ok) return;
//                                 tournamentSocket.emit('tournament_leaveTournament', {
//                                   tournamentId: t.id,
//                                   userName: username,
//                                 });
//                               }}
//                             >
//                               Отменить регистрацию
//                             </button>
//                           ) : (
//                             <>
//                               {t.registeredCount < t.maxPlayers ? (
//                                 <button
//                                   className="game-button"
//                                   onClick={() => {
//                                     const ok = window.confirm(
//                                       `Принять участие в турнире c buyIn=$${t.buyIn}?`
//                                     );
//                                     if (!ok) return;
//                                     tournamentSocket.emit('tournament_joinTournament', {
//                                       tournamentId: t.id,
//                                       userName: username,
//                                     });
//                                   }}
//                                 >
//                                   Регистрация
//                                 </button>
//                               ) : (
//                                 <p style={{ color: 'red' }}>Мест нет</p>
//                               )}
//                             </>
//                           )}
//                         </>
//                       ) : (
//                         <p style={{ color: 'red' }}>{t.status.toUpperCase()}</p>
//                       )}
//                       {/* При желании можно показать ещё что-то, например состояние сетки, если semifinal/final */}
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>

//       {/* Если хотите — рендерите Lobby. Иначе убирайте. */}
//       <TournamentLobby username={username} />
//     </div>
//   );
// }

// export default TournamentsPage;










// // TournamentsPage.jsx
// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useState, useEffect } from 'react';
// import TournamentLobby from './TournamentLobby';
// import './Lobby.css';
// import socket from './socket'; 
// import tournamentSocket from './socket'; 
// function TournamentsPage({ username }) {
//   const navigate = useNavigate();
//   const [allTournaments, setAllTournaments] = useState([]) 




//   // useEffect(() => {
//   //   // Подписываемся на событие
//   //   socket.on('responseAllTournaments', (data) => {
//   //     // Берём все турниры
//   //     setAllTournaments(data.allTournaments);
//   //   });

//   //   // Запрашиваем у сервера
//   //   socket.emit('requestAllTournaments');

//   //   return () => {
//   //     socket.off('responseAllTournaments');
//   //   };
//   // }, []); 
//   useEffect(() => {
//     // Функция-обработчик, которая будет получать массив tournaments
//     function handleAllTournamentsUpdated(all) {
//       console.log('[TournamentsPage] Получен список турниров:', all);
//       // Сохраняем всё как есть (в т.ч. finished)
//       setAllTournaments(all);
//     }

//     // 1) Подписываемся на ответ
//     tournamentSocket.on('responseAllTournaments', handleAllTournamentsUpdated);

//     // 2) Запрашиваем с сервера список
//     tournamentSocket.emit('requestAllTournaments');

//     // 3) Чистим подписку при размонтировании
//     return () => {
//       tournamentSocket.off('responseAllTournaments', handleAllTournamentsUpdated);
//     };
//   }, []);

// // TournamentLobby.jsx (пример)
// // useEffect(() => {
// //   function handleAllTournamentsUpdated(all) {
// //     // Сразу сетим как есть, чтобы видеть finished тоже
// //     console.log('[TournamentLobby] Получен список:', all);
// //     setTournaments(all);
// //   }

// //   tournamentSocket.on('responseAllTournaments', handleAllTournamentsUpdated);

// //   return () => {
// //     tournamentSocket.off('responseAllTournaments', handleAllTournamentsUpdated);
// //   };
// // }, []);
 

//   return (
//     <div className="casino-background"> 
//       <header className="header-banner">
//         {/* Логотип */}
//         <div className="logo">
//           <img src="/logo.png" alt="Logo" />
//           Ledis and Ganetmen
//         </div>

//         {/* Меню */}
//         <nav className="menu">
//           {/* Кеш => "/" */}
//           <a
//             className="menu-item"
//             href="/"
//             onClick={(e) => {
//               e.preventDefault();    // блокируем обычный переход
//               navigate('/');         // SPA-переход на "/"
//             }}
//           >
//             <span className="text">кеш</span>
//           </a>

//           {/* Турниры => "/tournamentsPage" */}
//           <a
//             className="menu-item"
//             href="/tournamentsPage"
//             onClick={(e) => {
//               e.preventDefault();
//               navigate('/tournamentsPage');
//             }}
//           >
//             <span className="text">турниры</span>
//           </a>

//           {/* Квесты => "/quests" (если у вас есть такой маршрут) */}
//           <a
//             className="menu-item"
//             href="/quests"
//             onClick={(e) => {
//               e.preventDefault();
//               navigate('/quests');
//             }}
//           >
//             <span className="text">квесты</span>
//           </a>
//         </nav>

//         {/* Кнопки */}
//         <div className="buttons">
//           <button className="button-login" onClick={() => navigate('/login')}>
//             Логин
//           </button>
//           <button
//             className="button-register"
//             onClick={() => navigate('/register')}
//           >
//             Регистрация
//           </button>
//         </div>
//       </header>

//       {/* Содержимое страницы: турнирный лобби */}
//       <TournamentLobby username={username} />
//     </div>
//   );
// }

// export default TournamentsPage;
